import { updateAnswersFromSourceCard } from "./updateDynamicAnswers";
import { updateItemsFromSourceCard } from "./updateDynamicItems";

export const updateAllDynamicAnswersAndItems = (cards) => {
  cards.forEach((card) => {
    const specs = card.specs;
    if (specs.has_dynamic_answers && !specs.dynamic_answers_custom && specs.dynamic_answers_source_question_token) {
      updateAnswersFromSourceCard({
        cards,
        sourceCardToken: specs.dynamic_answers_source_question_token,
        targetCard: card,
        recursive: false,
      });
    }
    if (specs.has_dynamic_items && !specs.dynamic_items_custom && specs.dynamic_items_source_question_token) {
      updateItemsFromSourceCard({
        cards,
        sourceCardToken: specs.dynamic_items_source_question_token,
        targetCard: card,
        recursive: false,
      });
    }
  });
};
